import { connect } from 'react-redux';
import lodash from 'lodash';
import { push } from 'react-router-redux';
import styles from './CreateEventType.scss';
import CreateEventType from './CreateEventType';
import {
    createEventType,
    getInstitutionDataSources,
    removeInstitutionDataSources,
    getInstitutionEventTypes,
    clearInstitutionEventTypes,
} from 'common/actions/eventTypes';
import {
    fetchApiIntegrations,
    cleanApiIntegrations,
} from 'common/actions/apiConfiguration';
import { getEnabledIntegrations } from 'common/selectors/apiConfiguration';

export function InstitutionalAdminCreateEventType(props) {
    return <CreateEventType
        className={styles.institutionalAdmin}
        {...props}
    />;
}

export default connect((state, props) => {
    const dataSources = lodash.get(state, 'dataSources');
    const enabledIntegrations = getEnabledIntegrations(state);
    const institutionEventTypes = lodash.get(state, 'eventTypes', []);
    const institutionId = lodash.get(state, 'me.institution.id');
    return {
        dataSources,
        enabledIntegrations,
        institutionEventTypes,
        institutionId,
    };
}, {
    pushRoute: () => push('/admin/events'),
    createEventType,
    getInstitutionDataSources,
    removeInstitutionDataSources,
    fetchApiIntegrations,
    cleanApiIntegrations,
    getInstitutionEventTypes,
    clearInstitutionEventTypes,
})(InstitutionalAdminCreateEventType);
